import { useEffect, useRef, useCallback } from "react";
import { useBlocker } from "react-router";

export const useUnsavedChangesGuard = (
  isDirty: boolean,
  onConfirmLeave: () => void,
  modal: {
    open: (config: {
      title: string;
      content: React.ReactNode;
      onOk: () => void;
      onCancel?: () => void;
      okText?: string;
      cancelText?: string;
    }) => void;
  },
) => {
  const isDirtyRef = useRef(isDirty);
  // eslint-disable-next-line react-hooks/refs
  isDirtyRef.current = isDirty;

  const blocker = useBlocker(() => isDirtyRef.current);

  useEffect(() => {
    if (blocker.state === "blocked") {
      modal.open({
        title: "Unsaved Changes",
        content: "You have unsaved changes. Are you sure you want to leave?",
        okText: "Leave page",
        cancelText: "Cancel",
        onOk: () => {
          blocker.proceed();
        },
        onCancel: () => {
          blocker.reset();
        },
      });
    }
  }, [blocker, modal]);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isDirtyRef.current) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);
};
